import { render } from "./Advertising.vue.js?vue&type=template&id=3163f13e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Advertising.vue?vue&type=template&id=3163f13e"
import script from "./Advertising.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Advertising.vue?vue&type=script&lang=js"
export * from "./Advertising.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Advertising.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/settings/Advertising.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3163f13e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3163f13e', __exports__)) {
    api.reload('3163f13e', __exports__)
  }
  
  module.hot.accept("./Advertising.vue.js?vue&type=template&id=3163f13e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Advertising.vue?vue&type=template&id=3163f13e", () => {
    api.rerender('3163f13e', render)
  })

}


export default __exports__